import { Box, Paper, Typography, styled } from '@mui/material';
import React from 'react';
import ReactApexCharts from 'react-apexcharts';
import CircleIcon from '@mui/icons-material/Circle';

interface PieChartInProcessProps {
  data?: {
    name: string;
    value: number;
  }[];
}
const colors = ['#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800', '#9B4EE9'];
const PieChartInProcess: React.FC<PieChartInProcessProps> = ({
  data = []
}: PieChartInProcessProps) => {
  return (
    <Paper>
      <Box sx={{ padding: 2, borderBottom: '1px solid lightgray' }}>
        <Typography variant="body1">สัดส่วนของประเภทบุคคลในพื้นที่กระบวนการผลิต</Typography>
      </Box>
      <Box sx={{ padding: 2, display: 'flex', justifyContent: 'center' }}>
        <ReactApexCharts
          options={{
            colors: colors,
            chart: {
              width: 380,
              type: 'pie'
            },
            labels: data.map((data) => data.name),
            legend: {
              show: false
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200
                  },
                  legend: {
                    position: 'bottom'
                  }
                }
              }
            ]
          }}
          series={data.map((data) => data.value)}
          type="pie"
          width={300}
          height={300}
        />
      </Box>
      <TopValueBox>
        <Typography>ประเภทบุคคล</Typography>
        <Typography>จำนวน</Typography>
      </TopValueBox>
      {data.map((item, index) => (
        <DataBox key={`${item.name}-${index}`}>
          <Box display="flex">
            <CircleIcon sx={{ marginRight: 1 }} style={{ color: colors[index % data.length] }} />
            <Typography>{item.name}</Typography>
          </Box>
          <Typography>{item.value}</Typography>
        </DataBox>
      ))}
    </Paper>
  );
};

export default PieChartInProcess;

const TopValueBox = styled('div')({
  backgroundColor: 'lightgray',
  display: 'flex',
  justifyContent: 'space-between',
  padding: 12
});

const DataBox = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  padding: 12
});
